export const relatedLinkBtnStyle = { padding: "2px 10px", borderRadius: 6 };

export function projectLinkLabel(project) {
  if (!project) return "—";
  return project.title || project.filecode || project.project_id || "—";
}

export function consultantLinkLabel(consultant) {
  if (!consultant) return "—";
  if (typeof consultant === "string") return consultant;
  return consultant.fullname || consultant.consultant_id || "—";
}

export function clientLinkLabel(client) {
  if (!client) return "—";
  if (typeof client === "string") return client;
  return (
    client.fullname ||
    `${client.surname || ""} ${client.name || ""}`.trim() ||
    client.client_id ||
    "—"
  );
}

export function documentLinkLabel(doc) {
  if (!doc) return "Document";
  return doc.title || doc.document_id || "Document";
}

export function propertyLinkLabel(prop) {
  if (!prop) return "Property";
  return prop.description || prop.property_id || "Property";
}

/** Display label for cash/accounting `kind` (API values E/P unchanged). */
export function cashTypeLabel(kind) {
  if (kind === "E") return "Debit";
  if (kind === "P") return "Credit";
  return "";
}

export const CASH_TYPE_FIELD_LABEL = "Type";

export function cashLinkLabel(cash) {
  if (!cash) return "Accounting entry";
  if (cash.reason) return cash.reason;
  const typeLabel = cashTypeLabel(cash.kind);
  return typeLabel || "Accounting";
}

export function bankClientAccountLinkLabel(acc) {
  if (!acc) return "—";
  return acc.accountnumber || acc.bankclientacco_id || "—";
}

export function bankProjectAccountLinkLabel(bpa) {
  if (!bpa) return "—";
  return (
    bpa.bankclientacco?.accountnumber ||
    bpa.project?.title ||
    bpa.bankprojacco_id ||
    "—"
  );
}

export function associatedClientLinkLabel(ac) {
  if (!ac) return "—";
  return (
    ac.project?.title ||
    clientLinkLabel(ac.client) ||
    ac.assoclient_id ||
    "—"
  );
}

export function clientContactLinkLabel(cc) {
  if (!cc) return "Contact";
  return cc.fullname || cc.clientcont_id || "Contact";
}

export function projectTaskLinkLabel(task) {
  if (!task) return "Task";
  return task.title || task.projtask_id || "Task";
}

export function professionalLinkLabel(pro) {
  if (!pro) return "—";
  return pro.fullname || pro.professional_id || "—";
}

export function resolveConsultant(consultant, fallbackConsultant) {
  if (consultant && typeof consultant === "object" && consultant.fullname) {
    return consultant;
  }
  if (fallbackConsultant && typeof fallbackConsultant === "object") {
    return fallbackConsultant;
  }
  if (consultant && typeof consultant === "object") return consultant;
  if (typeof consultant === "string") return { consultant_id: consultant, fullname: consultant };
  return fallbackConsultant || null;
}

export function consultantId(consultant) {
  if (!consultant) return null;
  if (typeof consultant === "string") return consultant;
  return consultant.consultant_id || null;
}
